import { Agent } from '../../../types/agent';

// Paleta fixa (referência: protótipo Claude Design). fg garante contraste.
const AGENT_COLORS: { bg: string; fg: string }[] = [
  { bg: '#F4CC04', fg: '#111111' },
  { bg: '#5bb8a5', fg: '#111111' },
  { bg: '#4a90d9', fg: '#ffffff' },
  { bg: '#8b7cf7', fg: '#ffffff' },
  { bg: '#e07a5f', fg: '#111111' },
  { bg: '#d9a04a', fg: '#111111' },
  { bg: '#9a6dd7', fg: '#ffffff' },
];

export interface AgentVisuals {
  initial: string;
  bg: string;
  fg: string;
}

/**
 * Identidade visual derivada do agente (sem campo no backend):
 * inicial do nome + cor estável por hash do id.
 */
export const getAgentVisuals = (agent: Pick<Agent, 'id' | 'name'>): AgentVisuals => {
  const color = AGENT_COLORS[agent.id % AGENT_COLORS.length];
  const initial = agent.name.trim().charAt(0).toUpperCase() || 'A';
  return { initial, ...color };
};

// Badges de escopo (mesmas cores do antigo AgentSelectorModal)
export const SCOPE_META: Record<string, { label: string; fg: string; bg: string }> = {
  global: { label: 'GLOBAL', fg: '#c4b5fd', bg: 'rgba(139,124,247,.12)' },
  workspace: { label: 'WORKSPACE', fg: '#93c5fd', bg: 'rgba(74,144,217,.12)' },
  group: { label: 'PESSOAL', fg: '#86efac', bg: 'rgba(91,184,165,.12)' },
};
